<!--
 * @@Author: MuYang
-->

<script>
import {LAYOUT_TYPE, createdEvent, initSchema, beforeCreateSchema} from '../../utils/share'
import { requestPrint } from './request'
import openEvent from '../mixin/open-event'
import exportPower from '../../../paas/components/basis/import-export/export-power'
import staticParams from '../mixin/params'
import pageRules from '../mixin/page-rules'
import i18n from './i18n.js'

const pageText = window.fe.getPageText(i18n)

export default {
  name: 'page-detail',
  provide () {
    return {
      formData: this.formData,
      store: this.store,
      subMap: this.subRelevance
    }
  },
  mixins: [openEvent, staticParams, pageRules],
  props: {
    params: Object,
    // // 页面权限
    // authCode: {
    //   type: Object,
    //   redirect: true
    // },
    pageRules: {
      type: Array,
      default () {
        return []
      }
    },
    // 业务配置
    config: {
      default: () => ({})
    },
    // 自定义对象数据权限
    menuApiName: {
      type: String,
      default: ''
    },
    // 弹窗相关配置
    popupConfig: {
      default: () => ({})
    },
    fetchSubData: {
      type: Function,
      default : () => {}
    }
  },
  data () {
    return {
      // 需要校验列表
      store: {
        tenantType: this.params.tenantType,
        objectApiName: this.params.objectApiName,
        layoutApiName: this.params.layoutApiName,
        saveRef: this.saveRef,
        popupConfig: this.popupConfig,
        fieldMap: () => this.fieldMap
      },
      // 保存提交从对象数据
      subRelevance: {},
      refMap: {},
      formData: {},
      pagination: {},
      schema: null,
      isLoad: false, // 加载完成
      // 准备状态
      readyState: {
        isSchema: false,
        isData: false
      }
    }
  },
  mounted () {
    this.getSchemaLayout()
  },
  // computed: {
  //   subSchema () {
  //     return this.schema?.subSchema || []
  //   }
  // },
  watch: {
    readyState: {
      async handler (val) {
        // 处理页面数据
        if (val.isSchema && val.isData) {
          await this.processSchema()
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取schema
    async getSchemaLayout () {
      this._schema = await beforeCreateSchema(this.requestParams, this.headerParams, this.config)
      this.$emit('schemaLoad', this._schema)
      // 请求从对象数据
      await this.fetchSubData(this._schema)
      this.readyState.isSchema = true
    },
    async processSchema () {
      // 初始化schema
      this.schema = await initSchema(this._schema, {
        btnsEvent: createdEvent.call(this),
        pageType: 'detail',
        config: this.config,
        isForm: true
      })
      this._initSaveSub(this.schema?.subSchema || [])
      this._updateData(this.formData)
      this._initPageRules(this.schema.pageRule)
      this.isLoad = true
      this.$nextTick(() => {
        this.$emit('loaded', this.schema)
      })
    },
    // 从对象存储列表
    _initSaveSub (subs = []) {
      const subRelevance = this.subRelevance
      subs.forEach(v => {
        // 如果是聚合页面, 初始化聚合从对象数据
        if (this.layoutType === LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_DETAIL) {
          if (this.formData.length === 0) { return }
          const itemData = this.formData[0]
          itemData[v.subObjectParamName] = this.formData
          this.formData = itemData
          // this.$set(this.formData, v.subObjectParamName, [this.formData])
        }
        this.$set(subRelevance, v.subObjectParamName, {
          dels: [],
          data: this.formData[v.subObjectParamName],
          fieldMap: this.fieldMap[v.objectApiName]
        })
      })
    },
    handlePrint (content, linkObjectModel) {
      if (!content || !content.elementApiName) {
        this.$message.error(pageText.templateIncorrect)
        return
      }
      const params = {
        objectApiName: this.objectApiName,
        operationApiName: linkObjectModel.operationApiName || this.operationApiName,
        id: this.id,
        printApiName: content.elementApiName,
        menuApiName: this.menuApiName
      }
      requestPrint(params, this.headerParams)
    },
    handleExport (params) {
      exportPower({
        menuApiName: this.menuApiName,
        ...this.requestParams,
        operationApiName: this.operationApiName,
        ...params
      })
    }
  },
  render (h) {
    const { isLoad, schema } = this
    return (
      <div>
        {
          isLoad ? (<render viewContent={schema?.nodes} />) : (<skeleton page='detail'></skeleton>)
        }
      </div>
    )
  }
}
</script>

<style scoped lang="scss"></style>

</style>
